export default function Ugolok() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={26} height={24} fill="none">
            <path stroke="#FFBB37" d="M1.59 23.58c-2-12.5 0-25.5 23.5-22.001"/>
        </svg>
    )
}